import { render, staticRenderFns } from "./KsVuetablePaginationInfo.vue?vue&type=template&id=7ee4a40d"
import script from "./KsVuetablePaginationInfo.vue?vue&type=script&lang=js"
export * from "./KsVuetablePaginationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports